import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetCurrencyTypes } from '@/graphql/contracts/_generated_/getCurrencyTypes.query';
import GetCurrencyTypesQuery from '@/graphql/contracts/getCurrencyTypes.query.gql';

export function getEnabledCurrencies(): Currency[] {
  const result = apolloClientContracts.readQuery<GetCurrencyTypes>({
    query: GetCurrencyTypesQuery
  });

  return result?.currencyTypes.filter((el) => el.enabled) || [];
}
